/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, TextField, Typography, alpha, useTheme } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, IVFormErrors, VSwitch, AutoCompleteGrupoDeProdutos, AutoCompleteSubgrupoProdutos, BasicSelect, VFieldMoney, VFieldMoneyNumber2, VFieldMoneyNumber4d, VFieldMoneyNumber4dn, VFieldMoney4 } from '../../../shared/forms';
import { FerramentasDeDetalhe, CartaoFlutuanteCarregando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';
import { LayoutBaseDeDashboard } from '../../../shared/layouts';
import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import NavTabs from './NavTabs';
import { styled } from '@mui/material/styles';
import { AutoCompleteCfop } from '../../../shared/forms/AutoCompleteCfop';
import { ProdutosService } from '../../../shared/services/api/estoque/produtos/ProdutosService';
import { DialogReferencia } from './DialogReferencia';
import { DialogAjusteEstoque, TTipoAjusteEstoque } from './DialogAjusteEstoque';
import { getAuth } from './../../../GlobalDecode';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type NullableDate = Date | null | undefined;

interface IFormData {
  idgrupo: string;
  foto: string;
  localizado: string;
  marca: string;
  idsubgrupo: string | null;
  descricao: string;
  un: string;
  ean: string;
  eanentrada: string;
  infadd: string;
  origem: number;
  cfop: string;
  icms: number;
  cst: string;
  cstpis: string;
  cstipi: string;
  cstcofins: string;
  ppis: number;
  pcofins: number;
  pipi: number;
  ncm: string;
  cest: string;
  descanp: string;
  pnacional: number;
  pimportado: number;
  vpartida: number;
  cprodanp: string;
  preco: number;
  pvenda: number;
  ppromocao: number;
  picms: number;
  pfrete: number;
  pseguro: number;
  desconto: number;
  precocusto: number;
  codinterno: string;
  comissao: number;
  margem: number;
  estoqueminino: number;
  tax: boolean;
  status: boolean;
}
const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  idgrupo: yup.string().required(),
  idsubgrupo: yup.string().nullable().default(null),
  descricao: yup.string().required(),
  foto: yup.string().optional().default(''),
  un: yup.string().required(),
  ean: yup.string().required(),
  eanentrada: yup.string().required(),
  localizado: yup.string().optional().default(''),
  marca: yup.string().optional().default(''),
  infadd: yup.string().optional().default(''),
  origem: yup.number().optional().default(0),
  cfop: yup.string().required(),
  icms: yup.number().optional().default(0),
  cst: yup.string().required(),
  cstcofins: yup.string().required(),
  cstpis: yup.string().required(),
  cstipi: yup.string().optional().default(''),
  pcofins: yup.number().optional().default(0),
  pipi: yup.number().optional().default(0),
  ppis: yup.number().optional().default(0),
  ncm: yup.string().required().min(8).max(8),
  cest: yup.string().optional().default(''),
  descanp: yup
    .string()
    .default('')
    .test(
      'descanp-length',
      'Deve ter entre 2 e 95 caracteres',
      (value) => !value || (value.length >= 2 && value.length <= 95)
    ),

  cprodanp: yup
    .string()
    .default('')
    .test(
      'cprodanp-length',
      'Deve ter entre 9 e 9 caracteres',
      (value) => !value || (value.length >= 9 && value.length <= 9)
    ),
  pnacional: yup.number().optional().default(0),
  pimportado: yup.number().optional().default(0),
  vpartida: yup.number().optional().default(0),
  preco: yup.number().required().moreThan(0),
  pvenda: yup.number().required().moreThan(0),
  ppromocao: yup.number().optional().default(0),
  picms: yup.number().optional().default(0),
  pfrete: yup.number().optional().default(0),
  pseguro: yup.number().optional().default(0),
  precocusto: yup.number().optional().default(0),
  desconto: yup.number().optional().default(0),
  comissao: yup.number().optional().default(0),
  margem: yup.number().optional().default(0),
  codinterno: yup.string().optional().default(''),
  estoqueminino: yup.number().optional().default(0),
  status: yup.boolean().optional().default(true),
  tax: yup.boolean().optional().default(true),
});

interface IDadosCombustivelForm {
  descanp: string;
  cprodanp: string;
  pnacional: string;
  pimportado: string;
  vpartida: string;
}

interface IDadosCombustivelValidado {
  descanp: string;
  cprodanp: string;
  pnacional: number;
  pimportado: number;
  vpartida: number;
}

const dadosCombustivelPadrao: IDadosCombustivelForm = {
  descanp: '',
  cprodanp: '',
  pnacional: '0',
  pimportado: '0',
  vpartida: '0',
};

const dadosCombustivelValidadoPadrao: IDadosCombustivelValidado = {
  descanp: '',
  cprodanp: '',
  pnacional: 0,
  pimportado: 0,
  vpartida: 0,
};

const combustivelValidationSchema = formValidationSchema.pick([
  'descanp',
  'cprodanp',
  'pnacional',
  'pimportado',
  'vpartida',
]);

const camposLabel: Record<string, string> = {
  idgrupo: 'Grupo',
  idsubgrupo: 'Subgrupo',
  descricao: 'Descrição',
  un: 'UN',
  ean: 'Código EAN',
  eanentrada: 'Código EAN Entrada',
  localizado: 'Local',
  marca: 'Marca',
  infadd: 'Observações',
  cfop: 'CFOP',
  cst: 'CST',
  cstcofins: 'CST COFINS',
  cstpis: 'CST PIS',
  cstipi: 'CST IPI',
  ncm: 'NCM',
  cest: 'CEST',
  descanp: 'Descrição ANP',
  cprodanp: 'Código ANP',
  pnacional: 'Percentual Nacional',
  pimportado: 'Percentual N. Importado',
  vpartida: 'Valor Partida',
  preco: 'Preço De Compra',
  comissao: 'Comissão (%)',
  icms: 'ICMS (%)',
  pseguro: 'Seguro',
  pfrete: 'Frete (%)',
  desconto: 'Desconto',
  ppromocao: 'Preço promoção',
  precocusto: 'Preço De Custo',
  margem: 'Mar. Lucro (%)',
  pvenda: 'Preço Venda',
  codinterno: 'Codigo Int',
  estoqueminino: 'Estoque Minimo',
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
  backgroundColor: theme.palette.background.paper,
}));

const ModernLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  marginBottom: theme.spacing(2),
}));

const RoundedTextField = styled(VTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));

const SectionBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '12px',
  backgroundColor: theme.palette.mode === 'dark'
    ? alpha(theme.palette.background.default, 0.5)
    : alpha('#f5f5f5', 0.3),
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));
const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
  maxWidth: '100%',
}));

export const DetalheDeProduto: React.FC = () => {
  const theme = useTheme();
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const location = useLocation();
  const voltarParaListagem = (location.state as { from?: string } | null)?.from || '/produto';
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [carregandoProduto, setCarregandoProduto] = useState(false);
  const { isSaving, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [image, setImage] = useState<string | null>(null);
  const [status, setStatus] = useState<boolean>();
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [openferais, setOpenFerias] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openCombustivel, setOpenCombustivel] = useState(false);
  const [dadosCombustivel, setDadosCombustivel] = useState<IDadosCombustivelForm>(dadosCombustivelPadrao);
  const [errosCombustivel, setErrosCombustivel] = useState<Record<string, string>>({});
  // Fonte de verdade dos campos de combustível — não fica em campos do VForm porque o
  // VTextField deste projeto é controlado via useState interno e só reagenda esse estado
  // de forma assíncrona; chamar save() logo em seguida a um setFieldValue lia o valor
  // antigo (o efeito de registro do campo ainda não tinha rodado). É um ref (não state)
  // de propósito: handleSave lê dadosCombustivelRef.current no momento da chamada, então
  // nunca pega um valor desatualizado por causa do ciclo de render do React, diferente do
  // que aconteceria se handleSave fechasse sobre um valor de useState.
  const dadosCombustivelRef = useRef<IDadosCombustivelValidado>(dadosCombustivelValidadoPadrao);
  const [quantidadeEstoque, setQuantidadeEstoque] = useState<number>(0);
  const [isLoadingEstoque, setIsLoadingEstoque] = useState(false);
  const [editandoEstoque, setEditandoEstoque] = useState(false);
  const [novoValorEstoque, setNovoValorEstoque] = useState('');
  const [ajusteEstoque, setAjusteEstoque] = useState<{ tipo: TTipoAjusteEstoque; quantidade: number } | null>(null);
  const [acaoEmAndamento, setAcaoEmAndamento] = useState<'criando' | 'atualizando' | 'deletando'>('atualizando');
  const auth = getAuth();
  const tipoimp = auth?.tipoimp ?? 1;
  const refs = auth?.refs;
  const decimais = auth?.decimais ?? 2;
  const est = auth?.est ?? false;

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate(voltarParaListagem);
    }
  };

  const handleDelete = () => {
    setOpenConfirm(true);
  };

  const handleConfirmDelete = () => {
    if (!iniciarSalvamento()) return;
    setOpenConfirm(false);
    setAcaoEmAndamento('deletando');

    ProdutosService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          cancelarSalvamento();
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
          concluirSalvamento();
        }
      });
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };


  const handleCloseFerias = () => {
    setOpenFerias(false);
  };
  const handleopenferias = () => {
    setOpenFerias(true);
  };

  const handleAbrirCombustivel = () => {
    const atual = dadosCombustivelRef.current;
    setDadosCombustivel({
      descanp: atual.descanp,
      cprodanp: atual.cprodanp,
      pnacional: String(atual.pnacional),
      pimportado: String(atual.pimportado),
      vpartida: String(atual.vpartida),
    });
    setErrosCombustivel({});
    setOpenCombustivel(true);
  };

  const handleFecharCombustivel = (event?: React.SyntheticEvent) => {
    // preventDefault/stopPropagation: este botão vive dentro do <VForm> do produto —
    // sem isso, o clique podia disparar o submit do formulário inteiro (Salvar produto)
    // em vez de só fechar esta dialog.
    event?.preventDefault();
    event?.stopPropagation();
    setOpenCombustivel(false);
  };

  const handleSalvarCombustivel = (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    combustivelValidationSchema
      .validate(dadosCombustivel, { abortEarly: false })
      .then((dadosValidados) => {
        const atual = dadosCombustivelRef.current;
        const houveAlteracao = dadosValidados.descanp !== atual.descanp
          || dadosValidados.cprodanp !== atual.cprodanp
          || dadosValidados.pnacional !== atual.pnacional
          || dadosValidados.pimportado !== atual.pimportado
          || dadosValidados.vpartida !== atual.vpartida;

        dadosCombustivelRef.current = dadosValidados;
        setErrosCombustivel({});
        setOpenCombustivel(false);

        // Só aciona o save do produto (handleSave da tela principal) se algo realmente
        // mudou — evita uma requisição de update desnecessária quando o usuário só abre
        // e fecha a dialog sem alterar nada.
        if (houveAlteracao) {
          save();
        }
      })
      .catch((errors: yup.ValidationError) => {
        const novosErros: Record<string, string> = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          novosErros[error.path] = error.message;
        });
        setErrosCombustivel(novosErros);
      });
  };

  const handleAbrirEdicaoEstoque = () => {
    if (editandoEstoque) return;

    const dados = (formRef.current?.getData() ?? {}) as IFormData;
    const { status: _status, ...dadosSemStatus } = dados;

    formValidationSchema
      .validate(dadosSemStatus, { abortEarly: false })
      .then(() => {
        setNovoValorEstoque(String(quantidadeEstoque));
        setEditandoEstoque(true);
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);

        const camposFaltantes = errors.inner
          .filter(error => !!error.path)
          .map(error => camposLabel[error.path as string] ?? error.path)
          .filter((valor, indice, lista) => lista.indexOf(valor) === indice)
          .join(', ');

        setTms('error');
        setMsg(`Corrija o cadastro do produto antes de ajustar o estoque. Campos pendentes: ${camposFaltantes}`);
        setOpenmsg(true);
      });
  };

  const handleCancelarEdicaoEstoque = () => {
    setEditandoEstoque(false);
  };

  const handleConfirmarEdicaoEstoque = () => {
    const novoValor = Number(novoValorEstoque.replace(',', '.'));
    if (isNaN(novoValor) || novoValor < 0) {
      setTms('error');
      setMsg('Informe uma quantidade válida.');
      setOpenmsg(true);
      return;
    }
    setEditandoEstoque(false);
    const diferenca = Number((novoValor - quantidadeEstoque).toFixed(4));
    if (diferenca === 0) return;
    setAjusteEstoque({
      tipo: diferenca > 0 ? 'entrada' : 'saida',
      quantidade: Math.abs(diferenca),
    });
  };

  const handleSucessoAjusteEstoque = (novaQuantidade: number) => {
    setQuantidadeEstoque(novaQuantidade);
    setAjusteEstoque(null);
  };

  const formatarNumero = (valor: number) => {
    return Number(valor.toFixed(decimais === 4 ? 4 : 2));
  };

  const zerarFormulario = () => {
    setQuantidadeEstoque(0);
    dadosCombustivelRef.current = { ...dadosCombustivelValidadoPadrao };
    formRef.current?.setData({
      idgrupo: '',
      idsubgrupo: null,
      descricao: '',
      foto: '',
      localizado: '',
      un: '',
      ean: 'SEM GTIN',
      eanentrada: 'SEM GTIN',
      marca: '',
      infadd: '',
      codigointerno: '',
      origem: 0,
      cfop: '',
      icms: 0,
      cst: '',
      cstcofins: '08',
      cstpis: '08',
      cstipi: '',
      pcofins: 0,
      ppis: 0,
      pipi: 0,
      ncm: '',
      cest: '',
      descanp: '',
      cprodanp: '',
      pnacional: 0,
      pimportado: 0,
      vpartida: 0,
      preco: 0,
      pvenda: 0,
      ppromocao: 0,
      picms: 0,
      pfrete: 0,
      pseguro: 0,
      desconto: 0,
      margem: 0,
      estoqueminino: 0,
      tax: true,
      status: true,
    });
    setImage(null);
    setTimeout(() => {
      calcularPrecoCusto();
    }, 100);
  };

  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      setCarregandoProduto(true);
      ProdutosService.getById(id)
        .then((result) => {
          if (result instanceof Error) {
            setIsLoading(false);
            setCarregandoProduto(false);
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setNome(result.descricao);
            setQuantidadeEstoque(result.quan || 0);
            dadosCombustivelRef.current = {
              descanp: result.descanp || '',
              cprodanp: result.cprodanp || '',
              pnacional: result.pnacional ?? 0,
              pimportado: result.pimportado ?? 0,
              vpartida: result.vpartida ?? 0,
            };
            const formData = {
              ...result,
              idsubgrupo: result.idsubgrupo || null,
            };
            formRef.current?.setData(formData);
            setTimeout(() => {
              calcularPrecoCusto();
              setIsLoading(false);
              setCarregandoProduto(false);
            }, 100);

          }
        });
    } else {
      zerarFormulario();
    }
  }, [id]);

  const handleSave = (dados: IFormData) => {
    if (!iniciarSalvamento()) return;
    setAcaoEmAndamento(id === 'novo' ? 'criando' : 'atualizando');

    const { status, ...dadosSemStatus } = dados;

    formValidationSchema
      .validate(dadosSemStatus, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        // descanp/cprodanp/pnacional/pimportado/vpartida não são mais campos do VForm —
        // ver comentário no dadosCombustivelRef — então dadosValidados sempre traria os
        // defaults do yup ('' / 0) para eles. Sobrescreve aqui com o que foi realmente
        // definido na dialog "Somente para Combustíveis".
        const dadosParaEnviar = id !== 'novo'
          ? { ...dadosValidados, ...dadosCombustivelRef.current, status }
          : { ...dadosValidados, ...dadosCombustivelRef.current };

        if (id === 'novo') {
          ProdutosService
            .create(dadosParaEnviar)
            .then((idProdutoCriado) => {
              setIsLoading(false);
              if (idProdutoCriado instanceof Error) {
                cancelarSalvamento();
                setTms('error');
                setMsg(idProdutoCriado.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Alteração concluída com sucesso!');
                setOpenmsg(true);
                concluirSalvamento();
                zerarFormulario();
                navigate(`/produto/${idProdutoCriado}`, { state: { from: voltarParaListagem } });
              }
            });
        } else {
          ProdutosService
            .updateById(id, dadosParaEnviar)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                cancelarSalvamento();
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Alteração concluída com sucesso!');
                setOpenmsg(true);
                concluirSalvamento();
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });

        formRef.current?.setErrors(validationErrors);
      });
  };

  const parseMoney = (
    value: string | number | null | undefined
  ): number => {
    if (typeof value === 'number') return value;
    if (!value) return 0;

    return Number(
      value
        .toString()
        .replace(/\./g, '')
        .replace(',', '.')
    ) || 0;
  };
  const handleMargemChange = (margem: number) => {
    const custo = calcularPrecoCusto();

    if (custo <= 0) return;

    const pvenda = custo + (custo * margem / 100);

    formRef.current?.setFieldValue(
      'pvenda',
      formatarNumero(pvenda)
    );
  };
  const handlePrecoVendaChange = (pvenda: number) => {
    const custo = calcularPrecoCusto();

    if (custo <= 0) return;

    const margem = ((pvenda - custo) / custo) * 100;

    formRef.current?.setFieldValue(
      'margem',
      Number(margem.toFixed(4))
    );
  };
  const calcularPrecoCusto = (override?: Partial<IFormData>) => {
    const data = formRef.current?.getData();

    const preco = parseMoney(override?.preco ?? data?.preco);
    const comissao = parseMoney(override?.comissao ?? data?.comissao);
    const icms = parseMoney(override?.icms ?? data?.icms);
    const seguro = parseMoney(override?.pseguro ?? data?.pseguro);
    const frete = parseMoney(override?.pfrete ?? data?.pfrete);

    const valorComissao = preco * (comissao / 100);
    const valorIcms = preco * (icms / 100);
    const valorFrete = preco * (frete / 100);

    const custo =
      preco +
      valorComissao +
      valorIcms +
      seguro +
      valorFrete;

    formRef.current?.setFieldValue(
      'precocusto',
      formatarNumero(custo)
    );

    return custo;
  };
  const handlePrecoCustoChange = (campo: keyof IFormData, valor: number) => {
    const custo = calcularPrecoCusto({ [campo]: valor });

    const data = formRef.current?.getData();
    const margem = parseMoney(data?.margem);

    if (!margem || margem === 0) {
      formRef.current?.setFieldValue(
        'pvenda',
        formatarNumero(custo)
      );
      return;
    }

    const pvenda = custo + (custo * margem / 100);

    formRef.current?.setFieldValue(
      'pvenda',
      formatarNumero(pvenda)
    );
  };
  return (
    <>
      <LayoutBaseDeDashboard
      barraDeFerramentas={
        <>
          <Box sx={{ marginLeft: '1%', marginRight: '1%', width: '97.5%', marginBottom: 0 }}>
            <NavTabs id={id} case={0} />
          </Box>
          <FerramentasDeDetalhe
            textoBotaoNovo='Novo'
            mostrarBotaoSalvarEFechar={id !== 'novo'}
            mostrarBotaoSalvarCarregando={isLoading}
            mostrarBotaoSalvarEFecharCarregando={isLoading}
            mostrarBotaoNovo={id !== 'novo'}
            mostrarBotaoApagar={id !== 'novo'}
            mostrarBotaoApagarCarregando={isLoading}
            mostrarBotaoImpressao={false}
            mostrarBotaoHistorico={false}
            mostrarBotaoferais={false}
            mostrarBotaoauxilio={false}
            mostrarBotaoHistoricoCarregando={false}
            mostrarBotaoferaisCarregando={isLoading}
            mostrarBotaoauxilioCarregando={isLoading}
            mostrarBotaoCartaoPonto={false}
            mostrarBotaoCartaoPontoCarregando={isLoading}
            mostrarBotaoCartaoPontoVerso={false}
            mostrarBotaoCartaoPontoVersoCarregando={isLoading}
            aoClicarEmSalvar={save}
            aoClicarEmSalvarEFechar={handleopenferias}
            aoClicarEmVoltar={() => navigate(voltarParaListagem)}
            mostrarBotaoVoltarCarregando={isLoading}
            aoClicarEmApagar={() => handleDelete()}
            aoClicarEmNovo={() => navigate('/produto/novo', { state: { from: voltarParaListagem } })}
            mostrarBotaoNovoCarregando={isLoading}
          />
        </>
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={msg.length > 60 ? 6000 : 2000} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
            }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>

        <ContentContainer>
          <StyledPaper elevation={0} sx={{ marginLeft: 0, marginRight: 0 }}>
            <CartaoFlutuanteCarregando open={carregandoProduto} message="Carregando produto..." />
            <CartaoFlutuanteCarregando
              open={isSaving}
              message={
                acaoEmAndamento === 'criando'
                  ? 'Criando produto...'
                  : acaoEmAndamento === 'deletando'
                    ? 'Deletando produto...'
                    : 'Atualizando produto...'
              }
            />
            <Grid container direction="column" spacing={3}>
              {isLoading && (
                <Grid item>
                  <ModernLinearProgress variant='indeterminate' />
                </Grid>
              )}

              <Grid item>
                <SectionBox>
                  <Grid container spacing={2} alignItems="center" >
                    <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3}>
                      <Box width='100%' display="flex" justifyContent="center">
                        <label htmlFor="avatar-input">
                          <Avatar
                            variant='rounded'
                            alt='Produto'
                            src={image || undefined}
                            sx={{
                              width: { xs: 150, sm: 150, md: 150, lg: 150, xl: 200 },
                              height: { xs: 180, sm: 180, md: 183, lg: 183, xl: 200 },
                              backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#f5f5f5',
                            }}
                          />
                        </label>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9.5} lg={9} xl={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='descricao'
                            disabled={isLoading}
                            label='Descrição'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='marca'
                            disabled={isLoading}
                            label='Marca'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='ean'
                            disabled={isLoading}
                            label='Código EAN'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='eanentrada'
                            disabled={isLoading}
                            label='Código EAN Entrada'
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='un'
                            disabled={isLoading}
                            label='UN'
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} md={2} lg={2} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='localizado'
                            disabled={isLoading}
                            label='Local'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <AutoCompleteGrupoDeProdutos />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={4}>
                          <AutoCompleteSubgrupoProdutos />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={2.5} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size='small'
                            name='codinterno'
                            disabled={isLoading}
                            label='Codigo Int'
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} lg={2.5} xl={2}>
                          <RoundedTextField
                            fullWidth
                            size="small"
                            name="estoqueminino"
                            disabled={isLoading}
                            label="Estoque Minimo"
                          />
                        </Grid>{id !== 'novo' && (
                          <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                            <Paper
                              elevation={0}
                              onClick={!editandoEstoque ? handleAbrirEdicaoEstoque : undefined}
                              sx={{
                                p: 0.5, // Reduzido de 1 para 0.5
                                textAlign: 'center',
                                cursor: editandoEstoque ? 'default' : 'pointer',
                                bgcolor: quantidadeEstoque <= 0
                                  ? alpha(theme.palette.error.main, 0.1)
                                  : alpha(theme.palette.success.main, 0.1),
                                borderRadius: 2,
                                border: `1px solid ${quantidadeEstoque <= 0
                                  ? theme.palette.error.main
                                  : theme.palette.success.main}`,
                              }}
                            >
                              <Typography variant="caption" color="textSecondary" fontSize="0.7rem">
                                Estoque
                              </Typography>
                              {editandoEstoque ? (
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  gap={0.5}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <TextField
                                    autoFocus
                                    type="number"
                                    size="small"
                                    variant="standard"
                                    value={novoValorEstoque}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => setNovoValorEstoque(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') handleConfirmarEdicaoEstoque();
                                      if (e.key === 'Escape') handleCancelarEdicaoEstoque();
                                    }}
                                    inputProps={{ style: { textAlign: 'center', fontSize: '0.875rem' } }}
                                    sx={{ width: 70 }}
                                  />
                                  <IconButton size="small" color="success" onClick={handleConfirmarEdicaoEstoque}>
                                    <CheckIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton size="small" color="error" onClick={handleCancelarEdicaoEstoque}>
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              ) : (
                                <Typography
                                  variant="body1" // Mudado de h6 para body1
                                  sx={{
                                    color: quantidadeEstoque <= 0 ? 'error.main' : 'success.main',
                                    fontWeight: 'bold',
                                    fontSize: '0.875rem' // Tamanho específico
                                  }}
                                >
                                  {quantidadeEstoque} {formRef.current?.getData()?.un || ''}
                                </Typography>
                              )}
                            </Paper>
                          </Grid>
                        )}

                        <Grid item xs={6} sm={6} md={4} lg={3} xl={3}>
                          <Box display="flex" alignItems="center" gap={2}>
                            <VSwitch
                              name='tax'
                              label='TAX'
                              value={status}
                              fdisabled={isLoading}
                              aliamento='start'
                            /> {id !== 'novo' && (
                              <VSwitch
                                name='status'
                                label='Status'
                                value={status}
                                fdisabled={isLoading}
                                aliamento='start'
                              />
                            )}

                          </Box>
                        </Grid>



                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <RoundedTextField
                        fullWidth
                        size='small'
                        name='infadd'
                        disabled={isLoading}
                        label='Observações'
                        multiline
                        rows={2}
                      />
                    </Grid>
                  </Grid>
                </SectionBox>
              </Grid>
              <Grid container spacing={2} marginLeft={0} marginTop={0}>
                <Grid item xs={12} md={6} xl={6}>
                  <SectionBox>
                    <Typography variant="h6" gutterBottom align="center" sx={{ mt: 1, mb: 2.1 }}>
                      Tributos
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={6}>
                        <RoundedTextField
                          fullWidth
                          size="small"
                          name="ncm"
                          disabled={isLoading}
                          label="NCM"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <BasicSelect
                          name='origem'
                          label='Origem'
                          data={[
                            { nameBD: '0', descricao: '0 - Nacional' },
                            { nameBD: '1', descricao: '01 - Estrangeira - Importação direta' },
                            { nameBD: '2', descricao: '02 - Estrangeira - Adquirida no mercado interno' },
                            { nameBD: '3', descricao: '03 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%' },
                            { nameBD: '4', descricao: '04 - Produto nacional fabricado conforme a legislação vigente.' },
                            { nameBD: '5', descricao: '05 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%;' },
                            { nameBD: '50', descricao: '50 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%;' },

                          ]}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <AutoCompleteCfop />
                      </Grid>
                      <Grid item xs={6}>
                        <BasicSelect
                          name='cst'
                          label='Cst'
                          data={[
                            { nameBD: '101', descricao: '101' },
                            { nameBD: '102', descricao: '102' },
                            { nameBD: '103', descricao: '103' },
                            { nameBD: '203', descricao: '203' },
                            { nameBD: '300', descricao: '300' },
                            { nameBD: '400', descricao: '400' },
                            { nameBD: '500', descricao: '500' },
                            { nameBD: '900', descricao: '900' },
                          ]}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <BasicSelect
                          name='cstcofins'
                          label='CST CONFIS'
                          data={[
                            { nameBD: '01', descricao: '01' },
                            { nameBD: '02', descricao: '02' },
                            { nameBD: '03', descricao: '03' },
                            { nameBD: '04', descricao: '04' },
                            { nameBD: '05', descricao: '05' },
                            { nameBD: '06', descricao: '06' },
                            { nameBD: '07', descricao: '07' },
                            { nameBD: '08', descricao: '08' },
                            { nameBD: '09', descricao: '09' },
                            { nameBD: '49', descricao: '49' },
                            { nameBD: '50', descricao: '50' },
                            { nameBD: '51', descricao: '51' },
                            { nameBD: '52', descricao: '52' },
                            { nameBD: '53', descricao: '53' },
                            { nameBD: '54', descricao: '54' },
                            { nameBD: '55', descricao: '55' },
                            { nameBD: '56', descricao: '56' },
                            { nameBD: '60', descricao: '60' },
                            { nameBD: '61', descricao: '61' },
                            { nameBD: '62', descricao: '62' },
                            { nameBD: '63', descricao: '63' },
                            { nameBD: '64', descricao: '64' },
                            { nameBD: '65', descricao: '65' },
                            { nameBD: '66', descricao: '66' },
                            { nameBD: '67', descricao: '67' },
                            { nameBD: '70', descricao: '70' },
                            { nameBD: '71', descricao: '71' },
                            { nameBD: '72', descricao: '72' },
                            { nameBD: '73', descricao: '73' },
                            { nameBD: '74', descricao: '74' },
                            { nameBD: '75', descricao: '75' },
                            { nameBD: '98', descricao: '98' },
                            { nameBD: '99', descricao: '99' },
                          ]}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <VFieldMoney
                          fullWidth
                          size='small'
                          name='pcofins'
                          label='Percentual CONFIS'
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <BasicSelect
                          name='cstpis'
                          label='CST PIS'
                          data={[
                            { nameBD: '01', descricao: '01' },
                            { nameBD: '02', descricao: '02' },
                            { nameBD: '03', descricao: '03' },
                            { nameBD: '04', descricao: '04' },
                            { nameBD: '05', descricao: '05' },
                            { nameBD: '06', descricao: '06' },
                            { nameBD: '07', descricao: '07' },
                            { nameBD: '08', descricao: '08' },
                            { nameBD: '09', descricao: '09' },
                            { nameBD: '49', descricao: '49' },
                            { nameBD: '50', descricao: '50' },
                            { nameBD: '51', descricao: '51' },
                            { nameBD: '52', descricao: '52' },
                            { nameBD: '53', descricao: '53' },
                            { nameBD: '54', descricao: '54' },
                            { nameBD: '55', descricao: '55' },
                            { nameBD: '56', descricao: '56' },
                            { nameBD: '60', descricao: '60' },
                            { nameBD: '61', descricao: '61' },
                            { nameBD: '62', descricao: '62' },
                            { nameBD: '63', descricao: '63' },
                            { nameBD: '64', descricao: '64' },
                            { nameBD: '65', descricao: '65' },
                            { nameBD: '66', descricao: '66' },
                            { nameBD: '67', descricao: '67' },
                            { nameBD: '70', descricao: '70' },
                            { nameBD: '71', descricao: '71' },
                            { nameBD: '72', descricao: '72' },
                            { nameBD: '73', descricao: '73' },
                            { nameBD: '74', descricao: '74' },
                            { nameBD: '75', descricao: '75' },
                            { nameBD: '98', descricao: '98' },
                            { nameBD: '99', descricao: '99' },
                          ]}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <VFieldMoney
                          fullWidth
                          size='small'
                          name='ppis'
                          label='Per PIS'
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <BasicSelect
                          name='cstipi'
                          label='CST IPI'
                          data={[
                            { nameBD: '', descricao: 'Vazio' },
                            { nameBD: '00', descricao: '00' },
                            { nameBD: '49', descricao: '49' },
                            { nameBD: '50', descricao: '50' },
                            { nameBD: '99', descricao: '99' },
                            { nameBD: '01', descricao: '01' },
                            { nameBD: '02', descricao: '02' },
                            { nameBD: '03', descricao: '03' },
                            { nameBD: '04', descricao: '04' },
                            { nameBD: '05', descricao: '05' },
                            { nameBD: '51', descricao: '51' },
                            { nameBD: '52', descricao: '52' },
                            { nameBD: '53', descricao: '53' },
                            { nameBD: '54', descricao: '54' },
                            { nameBD: '55', descricao: '55' },
                          ]}
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <VFieldMoney
                          fullWidth
                          size='small'
                          name='pipi'
                          label='Percentual IPI'
                          disabled={false}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <VFieldMoney
                          fullWidth
                          size="small"
                          name="picms"
                          disabled={isLoading}
                          label="P.ICMS"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <RoundedTextField
                          fullWidth
                          size="small"
                          name="cest"
                          disabled={isLoading}
                          label="CEST"
                        />
                      </Grid>
                    </Grid>
                  </SectionBox>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <SectionBox
                    onClick={handleAbrirCombustivel}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                      },
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ minHeight: 10 }}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <LocalGasStationIcon sx={{ fontSize: 18 }} />
                        <Typography variant="body2" fontWeight={600}>
                          Somente para Combustíveis
                        </Typography>
                      </Box>

                      <ChevronRightIcon sx={{ fontSize: 20 }} />
                    </Box>
                  </SectionBox>

                  <SectionBox >
                    <Typography variant="h6" gutterBottom align='center'>
                      Formando Preço
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="preco"
                            disabled={isLoading}
                            label="Preço De Compra"
                            calcular={(valor) => handlePrecoCustoChange('preco', valor)}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="preco"
                            disabled={isLoading}
                            label="Preço De Compra"
                            calcular={(valor) => handlePrecoCustoChange('preco', valor)}
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="comissao"
                            disabled={isLoading}
                            label="Comissão (%)"
                            calcular={(valor) => handlePrecoCustoChange('comissao', valor)}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="comissao"
                            disabled={isLoading}
                            label="Comissão (%)"
                            calcular={(valor) => handlePrecoCustoChange('comissao', valor)}
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="icms"
                            disabled={isLoading}
                            label="ICMS (%)"
                            calcular={(valor) => handlePrecoCustoChange('icms', valor)}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="icms"
                            disabled={isLoading}
                            label="ICMS (%)"
                            calcular={(valor) => handlePrecoCustoChange('icms', valor)}
                          />

                        )}
                      </Grid>

                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="pseguro"
                            disabled={isLoading}
                            label="Seguro"
                            calcular={(valor) => handlePrecoCustoChange('pseguro', valor)}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="pseguro"
                            disabled={isLoading}
                            label="Seguro"
                            calcular={(valor) => handlePrecoCustoChange('pseguro', valor)}
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="pfrete"
                            disabled={isLoading}
                            label="Frete (%)"
                            calcular={(valor) => handlePrecoCustoChange('pfrete', valor)}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="pfrete"
                            disabled={isLoading}
                            label="Frete (%)"
                            calcular={(valor) => handlePrecoCustoChange('pfrete', valor)}
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="desconto"
                            disabled={isLoading}
                            label="Desconto"
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="desconto"
                            disabled={isLoading}
                            label="Desconto"
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="ppromocao"
                            disabled={isLoading}
                            label="Preço promoção"
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="ppromocao"
                            disabled={isLoading}
                            label="Preço promoção"
                           sx={{
  '& .MuiInputBase-input': {
    fontSize: '1rem',
    fontWeight: 900,
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#000',
  },

  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: '#f5f5f5',
  },
}}
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="precocusto"
                            disabled={true}
                            label="Preço De Custo"
                             sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: theme.palette.text.primary,
                            fontSize: '1rem',
                            fontWeight: 900,
                            textRendering: 'optimizeLegibility', // melhora renderização
                            WebkitFontSmoothing: 'antialiased', // suaviza fonte no Mac
                            MozOsxFontSmoothing: 'grayscale', // suaviza fonte no Firefox
                          },
                          '& .MuiOutlinedInput-root.Mui-disabled': {
                            backgroundColor: theme.palette.action.hover,
                          },
                          '& .MuiInputLabel-root': {
                            fontWeight: 500,
                          },
                        }}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="precocusto"
                            disabled={true}
                            label="Preço De Custo"
                            sx={{
  '& .MuiInputBase-input': {
    fontSize: '1rem',
    fontWeight: 900,
  },

  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.text.primary,
  },

  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.action.hover,
  },
}}
                          />
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size="small"
                            name="margem"
                            disabled={isLoading}
                            label="Mar. Lucro (%)"
                            calcular={handleMargemChange}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size="small"
                            name="margem"
                            disabled={isLoading}
                            label="Mar. Lucro (%)"
                            calcular={handleMargemChange}
                          />
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {decimais === 4 ? (
                          <VFieldMoneyNumber4dn
                            fullWidth
                            size='small'
                            name="pvenda"
                            disabled={isLoading}
                            label="Preço Venda"
                            calcular={handlePrecoVendaChange}
                          />
                        ) : (
                          <VFieldMoneyNumber2
                            fullWidth
                            size='small'
                            name='pvenda'
                            label='Preço Venda'
                            disabled={isLoading}
                            calcular={handlePrecoVendaChange}
                          />
                        )}
                      </Grid>

                    </Grid>
                  </SectionBox>
                </Grid>
              </Grid>
            </Grid>
            <Dialog open={openCombustivel} onClose={() => setOpenCombustivel(false)} fullWidth maxWidth="sm">
              <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocalGasStationIcon fontSize="small" />
                Dados de Combustível
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
                  <Grid item xs={8}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Descrição ANP"
                      value={dadosCombustivel.descanp}
                      error={!!errosCombustivel.descanp}
                      helperText={errosCombustivel.descanp}
                      onChange={(e) => setDadosCombustivel(old => ({ ...old, descanp: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Código ANP"
                      value={dadosCombustivel.cprodanp}
                      error={!!errosCombustivel.cprodanp}
                      helperText={errosCombustivel.cprodanp}
                      onChange={(e) => setDadosCombustivel(old => ({ ...old, cprodanp: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Percentual Nacional"
                      value={dadosCombustivel.pnacional}
                      error={!!errosCombustivel.pnacional}
                      helperText={errosCombustivel.pnacional}
                      onChange={(e) => setDadosCombustivel(old => ({ ...old, pnacional: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Percentual N. Importado"
                      value={dadosCombustivel.pimportado}
                      error={!!errosCombustivel.pimportado}
                      helperText={errosCombustivel.pimportado}
                      onChange={(e) => setDadosCombustivel(old => ({ ...old, pimportado: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Valor Partida"
                      value={dadosCombustivel.vpartida}
                      error={!!errosCombustivel.vpartida}
                      helperText={errosCombustivel.vpartida}
                      onChange={(e) => setDadosCombustivel(old => ({ ...old, vpartida: e.target.value }))}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button type="button" color="inherit" onClick={handleFecharCombustivel}>Cancelar</Button>
                <Button type="button" variant="contained" onClick={handleSalvarCombustivel}>Salvar</Button>
              </DialogActions>
            </Dialog>
            <DialogReferencia
              id={id}
              value={""}
              open={openferais}
              onClose={handleCloseFerias}
            />
            <DialogAjusteEstoque
              open={ajusteEstoque !== null}
              tipoAjuste={ajusteEstoque?.tipo ?? 'entrada'}
              idproduto={id}
              descricaoProduto={nome}
              un={formRef.current?.getData()?.un || ''}
              precoUnitario={
                ajusteEstoque?.tipo === 'entrada'
                  ? Number(formRef.current?.getData()?.preco) || 0
                  : Number(formRef.current?.getData()?.pvenda) || 0
              }
              quantidadeAjuste={ajusteEstoque?.quantidade ?? 0}
              quantidadeAtual={quantidadeEstoque}
              onClose={() => setAjusteEstoque(null)}
              onSuccess={handleSucessoAjusteEstoque}
            />
          </StyledPaper>
        </ContentContainer>
      </VForm>
      </LayoutBaseDeDashboard>
    </>
  );
};